export default __webpack_public_path__ + "static/media/mentalHealth4.6120fc09.jpeg";